import { css } from 'styled-components';
import { tokens } from '@nib-group/design-tokens/build/web';
export const TOKEN_NOT_FOUND_CSS_VAR = `--token-not-found`;
function getToken(path, fallback) {
  let token = tokens[path];
  // if the token is not found - replacing it with variable name without any value, to avoid it being undefined which would result in invalid css
  if (!token) {
    token = TOKEN_NOT_FOUND_CSS_VAR;
  }
  const tokenCall = fallback ? typeof fallback === 'function' ? css`var(${token}, ${fallback})` : `var(${token}, ${fallback})` : `var(${token})`;
  return tokenCall;
}
export default getToken;